/**
 * Auth headers for fetch-based API calls (history / favorites / collections).
 *
 * With auth enabled: Bearer token (backend derives user from the JWT).
 * Dev mode: legacy X-User-ID header from localStorage.
 */

export function authHeaders(): Record<string, string> {
  const token = localStorage.getItem('auth_token');
  if (token) {
    return { Authorization: `Bearer ${token}` };
  }
  return { 'X-User-ID': localStorage.getItem('user_id') || 'anonymous' };
}
